import React, { memo, forwardRef, useContext } from 'react';
import cn from 'classnames';
import { Box } from '../../box';
import { ModalContext } from '../contexts';
import baseStyles from '../styles.module.css';
import styles from './styles.module.css';
export const Body = memo(forwardRef(function Body({ children, className, ...props }, ref) {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('Modal component has to be placed inside Modal.Overlay');
    }
    const { modalProps: { size }, } = context;
    return (React.createElement(Box, { ref: ref, className: cn(baseStyles.body, styles.body, className), p: size, flexDirection: "column", ...props }, children));
}));
